import * as API from './apiBase';

let baseList = {
    GetInvoiceType: 'api/InvoiceNew/GetInvoiceType',
    GetInvoiceStatus: 'api/InvoiceNew/GetInvoiceStatus',
    GetInvoiceList: 'api/InvoiceNew/GetInvoiceList',
    DelInvoice: 'api/InvoiceNew/DelInvoice',
    GetInvoiceDetail: 'api/InvoiceNew/GetInvoiceDetail',
    ReadInvoiceFile: 'api/InvoiceNew/ReadInvoiceFile',
    GetRealNameReasonCode: 'api/InvoiceNew/GetRealNameReasonCode',
    UpdateInvoiceRemarks: 'api/InvoiceNew/UpdateInvoiceRemarks',
    UpdateInvoiceDetail: 'api/InvoiceNew/UpdateInvoiceDetail',
}

/*获取发票类型 */
export const GetInvoiceType = (language) => {
    return API.POST(baseList.GetInvoiceType, {
        language
    })
};

export const GetInvoiceStatus = (language) => {
    return API.POST(baseList.GetInvoiceStatus, {
        language
    })
};

/*获取我的发票列表 */
export const GetInvoiceList = (username, access_token, SearchKey, InvoiceTypeCode, AmountStart, AmountEnd, InvoiceDateStart, InvoiceDateEnd, IsEdit, InvoiceStatus, SortFlag, PageIndex, PageSize, language, CompanyCode, BeAgentCode) => {
    return API.POST(baseList.GetInvoiceList, {
        username,
        access_token,
        SearchKey,
        InvoiceTypeCode,
        AmountStart,
        AmountEnd,
        InvoiceDateStart,
        InvoiceDateEnd,
        IsEdit,
        InvoiceStatus,
        SortFlag,
        PageIndex,
        PageSize,
        language,
        CompanyCode,
        BeAgentCode
    })
};

/*删除发票 */
export const DelInvoice = (Id, language) => {
    return API.POST(baseList.DelInvoice, {
        Id,
        language
    })
};

/*OCR读取发票文件 */
export const ReadInvoiceFile = (username, FileId, Client, language, CompanyCode, BeAgentCode) => {
    return API.POST(baseList.ReadInvoiceFile, {
        username,
        FileId,
        Client,
        language,
        CompanyCode,
        BeAgentCode
    })
};

/*获取发票明细 */
export const GetInvoiceDetail = (Id, language) => {
    return API.POST(baseList.GetInvoiceDetail, {
        Id,
        language
    })
};

/*获取原因列表 */
export const GetRealNameReasonCode = () => {
    return API.POST(baseList.GetRealNameReasonCode, {})
};


/*更新发票备注 */
export const UpdateInvoiceRemarks = (Id, InvoiceRemarks) => {
    return API.POST(baseList.UpdateInvoiceRemarks, {
        Id,
        InvoiceRemarks
    })
};

/*编辑数据/确定提交 */
export const UpdateInvoiceDetail = (Id, main, item, language, username, NotPersonalRemarks) => {
    return API.POST(baseList.UpdateInvoiceDetail, {
        Id,
        main,
        item,
        language,
        username,
        NotPersonalRemarks
    })
};
